import { useCallback } from 'react';

import { Modals } from 'Services/Modals';
import { ModalHeader } from 'App/Modals/templates/Default/components/ModalHeader';
import { getFullUrl } from 'Utils/getFullUrl';

import { trackGiftAndShareModalDismissed } from '../biEvents';

import { Separator } from './components/Separator';
import { ShareItem } from './ShareItem';
import { GiftItem } from './GiftItem';
import { GenerateGiftItem } from './GenerateGiftItem';

import type { GiftItemT } from 'Services/api/giftLink/types';

type PropsT = {
  articleLink: string;
  availableGift: GiftItemT | null;
  availableGiftTotal: number;
  giftLink: string | null;
  goToGenerateLinkView: () => void;
  onMobileShare: (url: string, addSourceParam?: boolean) => void;
  isMpArticle?: boolean;
  ariaDialogLabelId: string;
};

export const MainView: React.FunctionComponent<PropsT> = ({
  articleLink,
  availableGift,
  availableGiftTotal,
  giftLink,
  goToGenerateLinkView,
  onMobileShare,
  isMpArticle,
  ariaDialogLabelId,
}) => {
  const handleClose = useCallback(() => {
    trackGiftAndShareModalDismissed();
    Modals.removeCurrentModal();
  }, []);

  return (
    <>
      <ModalHeader
        ariaDialogLabelId={ariaDialogLabelId}
        title="Gift & Share"
        variant="action"
        onClose={handleClose}
      />

      <div className="pt-30">
        {giftLink ? (
          <GiftItem
            availableGift={availableGift}
            availableGiftTotal={availableGiftTotal}
            giftLink={giftLink}
            onMobileShare={onMobileShare}
          />
        ) : (
          <GenerateGiftItem
            availableGiftTotal={availableGiftTotal}
            goToGenerateLinkView={goToGenerateLinkView}
            isMpArticle={isMpArticle}
          />
        )}

        <Separator />

        <ShareItem
          availableGiftTotal={availableGiftTotal}
          isMpArticle={isMpArticle}
          shareLink={getFullUrl(articleLink)}
          onMobileShare={onMobileShare}
        />
      </div>
    </>
  );
};
